<template>
  <modal title="Add Terminal Manager" width="45" :showModal="showModal" @close-modal="closeModal">
    <div class="flex flex-col" v-loading="loading">
      <div class="flex justify-between my-4">
        <h3 class="mt-4 mb-3 text-lg">All Users</h3>
        <base-button @click="$router.push({name:'AddNewUser'})" text="Create User" />
      </div>
   
      <div class="table__search-input-wrapper mb-2">
        <span class="pr-2 opacity-50">
          <search-icon />
        </span>
        <input type="text" class="table__search-input" placeholder="Search and add Members from here "
          v-model="filterQuery" />
        <img src="@/assets/images/icons/search.svg" alt="search icon" />
      </div>

      <div class="grid grid-cols-1 gap-2 max-h-40 overflow-y-scroll" style="max-height:12rem">
        <div v-for="user in filteredUsers" :key="user.id" :class="{ 'bg-gray-400': selectedUser.id == user.id }"
          class="flex justify-between items-center p-2 cursor-pointer m-2 rounded-lg" style="border: 1px dashed gray"
          @click.prevent="selectUser(user)">
          <div class="flex gap-2">
            <div class="w-10 h-10 rounded-full bg-gray-300 text-center pt-2 text-black" alt="search icon">{{ user.firstname.slice(0,1) }}{{ user.lastname.slice(0,1) }}</div>
            <div class="flex flex-col">
              <a href="#" style="color:black;">
                <h3 class="font-semibold text-base">
                  {{ user.firstname + " " + user.lastname }}
                </h3>
              </a>
              <small class="text-gray-500">{{ user.email || "N/A" }}</small>
            </div>
          </div>
        </div>
      </div>
      
      <div class="flex items-center justify-between">
        <div class="cursor-pointer" @click="$router.go(-1)">
          <p>Cancel</p>
        </div>
        <base-button text="Add" @click="addManager" :disable="disabled" />
      </div>
    </div>
    <add-users-modal :showModal="showUserModal" @refetch-user="refetchUser" @close-modal="showUserModal = false" />
  </modal>
</template>

<script>
import AddUsersModal from './AddUsersModal.vue';
export default {
  components: { AddUsersModal },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    creatingGroup: {
      type: Boolean,
      required: false,
    },
    isButtonDisabled: {
      type: Boolean,
      required: false,
    },
    refreshGroups: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      users: [ 
      ],
      selectedUsers: [],
      selectedUser: "",
      showOptions: false,
      showUserModal: false,
      role: "",
      roles: [],
      filterQuery: "",
      loading: false,
    };
  },
  computed: {
    filteredUsers() {
      if(this.users.length > 0){
        return this.users.filter(
          (user) =>
            user.firstname.toUpperCase().indexOf(this.filterQuery.toUpperCase()) > -1
        );
      }else {
        return []
      }
      
    },
  },
  mounted() {
    this.getUsers();
  },
  watch: {
    refreshGroups() {
      if (this.refreshGroups) {
        this.selectedUsers = [];
      }
    },
  },
  methods: {
    async getAllRoles() {
      try {
        let response = await this.$_getRoles();

        this.roles = response.data.roles;
      } catch (error) {
        this.handleError(error);
      }
    },
    async getUsers() {
      try {
        let response = await this.$_getOrgUsers();

        this.users = response.data.data.users;
      } catch (error) {

        this.handleError(error);
      }
    },
    selectUser(user) {
      this.selectedUser = user;
    },
    addManager() {
      this.$emit("new-location-manager", this.selectedUser);
      this.closeModal();
    },
    refetchUser(){
      this.getUsers()
    },
    disabled() {
      return true;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}

.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
